// Opening a dropdown closes the one that is open (bootstrap-vue does it with a root event).
const listeners = new Map()

// tells every other open dropdown that this one has opened
export const dropdownOpened = (id) => {
  Array.from(listeners.entries()).forEach(([otherId, close]) => {
    if(otherId !== id) close()
  })
}

// registers an open dropdown; returns the function that removes it
export const onOtherDropdownOpened = (id, close) => {
  listeners.set(id, close)
  return () => listeners.delete(id)
}
